<app-modal
  [title]="'Input voucher code' | trans:'vouchers/voucher-code-input-modal/header/title'"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <div>
      <app-form-control
        label="{{ 'Code'| trans:'vouchers/voucher-code-input-modal/code.Label' }}"
      >
        <input
          #codeInput
          type="text"
          [(ngModel)]="code"
          [disabled]="isLoading()"
          (keydown.enter)="onSubmit()"
          placeholder="{{ 'Enter voucher code'| trans:'vouchers/voucher-code-input-modal/code.Placeholder' }}"
        >
      </app-form-control>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        [disabled]="isLoading()"
        (click)="close()"
      >
        {{ 'Cancel'| trans:'vouchers/voucher-code-input-modal/cancel.Button' }}
      </button>
      <button
        class="button button--md button--primary text-uppercase"
        [disabled]="!code || isLoading()"
        (click)="onSubmit()"
      >
        {{ 'Confirm'| trans:'vouchers/voucher-code-input-modal/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

<app-external-voucher-ticket-picker-modal
  #externalVoucherTicketPickerModal
  (ticketSelected)="onAcardoTicketSelected($event)"
/>
